/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React, {  useState, useCallback, type MouseEvent } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {  useWatch, type FieldValues } from 'react-hook-form';
import type { CustomTextFieldProps } from '../CustomTextField/CustomTextField';
import CustomTextField from '../CustomTextField/CustomTextField';
import './CustomPasswordElement.module.css';
import { useTranslation } from '../../Translation/translationProvider';

export interface CustomPasswordElementProps<T extends FieldValues = FieldValues>
  extends CustomTextFieldProps<T> {
  isWithRepeat?: boolean;
  name: string;
  label: string;
  confirmLabel?: string;
}

// Define React.FC with generic props
const CustomPasswordElement: React.FC<CustomPasswordElementProps> = (props) => {
  const { t } = useTranslation();
  const { isWithRepeat = false, name, label, confirmLabel, ...rest } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const pwValue = useWatch({
    name,
    control: rest.control,
  });

  const handleTogglePassword = useCallback(() => setShowPassword((prev) => !prev), []);
  const handleToggleConfirmPassword = useCallback(() => setShowConfirmPassword((prev) => !prev), []);

  const renderPasswordToggleIcon = (visible: boolean, onClick: () => void) => (
    <InputAdornment position="end">
      <IconButton
        onMouseDown={(e: MouseEvent<HTMLButtonElement>) => e.preventDefault()}
        onClick={onClick}
        tabIndex={-1}
        color="default"
      >
        {visible ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <>
      <CustomTextField
        {...rest}
      /*   style={{
          width: '400px',
          background: '#FFFFFF',
          border: '1px solid #CFD1D7',
          boxSizing: 'border-box',
          left:'24px'
        }}  */
        // className="input-field-password"
        name={name}
        label={label}
        InputProps={{
          endAdornment: renderPasswordToggleIcon(showPassword, handleTogglePassword),
        }}
        type={showPassword ? 'text' : 'password'}
      />
      

      {isWithRepeat && (
        <CustomTextField
          {...rest}
          // style={{ marginTop: '0px', marginBottom: '16px', background:'#FFFFFF' }}
         /*  style={{
            width: '400px',
            background: '#FFFFFF',
            border: '1px solid #CFD1D7',
            boxSizing: 'border-box',
            left:'24px'
          }}  */
          // className="lowHeight"
          name={`${name}_repeat`}
          label={confirmLabel ? confirmLabel :`Confirm ${label}`}
          InputProps={{
            endAdornment: renderPasswordToggleIcon(showConfirmPassword, handleToggleConfirmPassword),
          }}
          type={showConfirmPassword ? 'text' : 'password'}
          validation={{
            validate: (value: string) =>
              value === pwValue || t('common.passwordMismatch'),
          }}
        />
      )}
    </>
  );
};

export default React.memo(CustomPasswordElement);
